import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { footerLinks } from "../mock";
import { Twitter, Linkedin, Github } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-slate-50/60">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:grid-cols-6">
          <div className="col-span-2">
            <Logo />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-600">
              The authority-grade beacon for ready buyers. Cut through the
              noise — identify, connect, and close with confidence.
            </p>
            <div className="mt-5 flex items-center gap-2">
              {[Twitter, Linkedin, Github].map((Ic) => (
                <a
                  key={Ic.displayName || Ic.name}
                  href="#"
                  className="flex h-8 w-8 items-center justify-center rounded-md border border-slate-200 bg-white text-slate-500 transition-colors hover:border-[#1e1b4b]/20 hover:text-[#1e1b4b]"
                >
                  <Ic className="h-3.5 w-3.5" />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([cat, items]) => (
            <div key={cat}>
              <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-500">
                {cat}
              </div>
              <ul className="mt-4 flex flex-col gap-2.5">
                {items.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-slate-600 transition-colors hover:text-[#1e1b4b]"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-slate-200 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center">
          <div>
            © {new Date().getFullYear()} BuyerBeacon Pro. All rights reserved.
            <span className="ml-2 hidden sm:inline">Built by 11x founders for small business.</span>
          </div>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-[#1e1b4b]">Privacy</Link>
            <Link to="/terms" className="hover:text-[#1e1b4b]">Terms</Link>
            <Link to="/security" className="hover:text-[#1e1b4b]">Security</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
